import { Tag } from 'antd';
import { FC, memo } from 'react';

import { Domain, DomainDeployStatus } from '@/modules/Domains';

interface Props {
  status: Domain['deployStatus'];
}

export const DomainDeployStatusTag: FC<Props> = memo(({ status }) => {
  if (status === DomainDeployStatus.NotDeployed) return <Tag color="default">Не розгорнутий</Tag>;

  if (status === DomainDeployStatus.Deployed) return <Tag color="success">Розгорнутий</Tag>;

  if (status === DomainDeployStatus.Deploying) return <Tag color="processing">Розгортання</Tag>;

  if (status === DomainDeployStatus.Shutdowning) return <Tag color="processing">Згортання</Tag>;

  if (status === DomainDeployStatus.Failed) return <Tag color="error">Помилка</Tag>;

  if (status === DomainDeployStatus.Pending) return <Tag color="orange">В черзі</Tag>;
});
